import { settings } from '../../../settings/settings-util';
import reducer from './reducers/index';
import ResponseActionHandler from './response-action-handler';
import OkPane from './renderers/okPane';
import RadioOptionPane from './renderers/radioOptionPane';
import TextAreaPane from './renderers/textAreaPane';
import TransitionPane from './renderers/transitionPane';
import YesnoPane from './renderers/yesnoPane';
import { DataCollectionPane } from './renderers/DataCollectionPane';
import Overlay from './renderers/overlay';
import CalendarWidgetPane from './renderers/calendarWidgetPane';

export default class WindowFeedbackOverlay {
    constructor(passedSettings, performCustomValidations = () => true) {
        this._settings = passedSettings || settings;
        this._responseActionHandler = new ResponseActionHandler(this._settings);
        this._panes = [
            new OkPane(this._settings, [], []),
            new RadioOptionPane(this._settings, [], []),
            new TextAreaPane(this._settings, [], []),
            new TransitionPane(this._settings, [], []),
            new YesnoPane(this._settings, [], []),
            new DataCollectionPane(this._settings, [], [], performCustomValidations),
            new CalendarWidgetPane(this._settings, [], [])
        ];
    }

    static getDefaultSettings() {
        return settings;
    }

    getResponseActionHandler() {
        return this._responseActionHandler;
    }

    getReducer() {
         return reducer;
    }

    getPaneRenderers() {
        return this._panes;
    }

    getOverlayRenderer() {
        return Overlay;
    }

    initialize(store) {
        this._store = store;
    }

    initializePanes(store) {
        this._panes.forEach((pane) => {
            pane.initialize(store);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/window-feedback-overlay.js